// extracted by mini-css-extract-plugin
export default {"container":"Cq-z","blurb":"Dq-z","links":"Eq-z"};